import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';

import {ApplicationState} from '../../application-state/store';
import {PartnerWebsitesActions} from '../store';
import {PartnerWebsitesSelectors} from '../store/selectors';

@Injectable()
export class PartnerWebsitesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadPartnerWebsites().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadPartnerWebsites() {

    return this.store.pipe(
      select(PartnerWebsitesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(PartnerWebsitesActions.ReadPartnerWebsites({page: 1}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
